"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainLinkAddConsumerButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const wagmi_1 = require("wagmi");
const viem_1 = require("viem");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const addConsumer_json_1 = __importDefault(require("@framework/abis/json/VRFCoordinatorV2PlusMock/addConsumer.json"));
const dialogs_1 = require("../../../../dialogs");
const ChainLinkAddConsumerButton = (props) => {
    const { contractId, subscriptionId, className, disabled, variant = styled_1.ListActionVariant.button } = props;
    const { address: account } = (0, wagmi_1.useAccount)();
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const metaAddConsumer = (0, react_hooks_eth_1.useSystemContract)(async (values, systemContract) => {
        // https://docs.chain.link/docs/link-token-contracts/
        const subId = (0, viem_1.pad)((0, viem_1.toHex)(BigInt(values.vrfSubId).toString()), { size: 32 });
        return writeContractAsync({
            address: systemContract.address,
            abi: addConsumer_json_1.default,
            functionName: "addConsumer",
            args: [subId, values.address],
        });
    });
    const { execute: metaFnAddConsumer } = (0, react_hooks_eth_1.useMetamask)((values) => {
        return metaAddConsumer(types_1.SystemModuleType.CHAIN_LINK, values);
    });
    const handleAddConsumerConfirm = async ({ data }) => {
        await metaFnAddConsumer(data);
    };
    const handleAddConsumer = () => {
        openDialog(dialogs_1.GlobalDialogKeys.CONTRACT_MINT, {}, {
            initialValues: {
                vrfSubId: subscriptionId,
                address: "0x",
                contractId,
            },
            message: "dialogs.vrfConsumer",
            testId: "ChainLinkAddConsumerForm",
            onExternalConfirm: handleAddConsumerConfirm,
        });
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleAddConsumer, icon: icons_material_1.RecentActors, message: "form.buttons.addConsumer", className: className, dataTestId: "ChainLinkAddConsumerButton", disabled: disabled || !account, variant: variant }));
};
exports.ChainLinkAddConsumerButton = ChainLinkAddConsumerButton;
//# sourceMappingURL=index.js.map